import {Component, Injector, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import RegroupementPlatDTO from "../../../core/dtos/conditionnement/regroupement-plat-d-t-o";
import {Subscription} from "rxjs";
import {UtilsService} from "../../../core/utils/utils.service";
import {RegroupementPlatService} from "../../../core/services/conditionnements/regroupement/regroupement-plat.service";
import {
  RegroupementPlatFilterMl
} from "../../../core/models/gestion-conditionnements/regroupement/plat/regroupement-plat-filter-ml";
import {RegroupementPlatDialogPlatsComponent} from "./plat/regroupement-plat-dialog-plats.component";
import {
  RegroupementPlatDialogFicheTechniqueComponent
} from "./fiche-technique/regroupement-plat-dialog-fiche-technique.component";
import {RegroupementPlatDialogPlcComponent} from "./plc/regroupement-plat-dialog-plc.component";
import {ItemNavigationService} from "../../../core/services/technique/item-navigation.service";

@Component({
  selector: 'yo-regroupement-plat-dialog',
  templateUrl: './regroupement-plat-dialog.component.html',
  styleUrls: ['./regroupement-plat-dialog.component.scss']
})

export class RegroupementPlatDialogComponent implements OnInit, OnDestroy {
  regroupement: RegroupementPlatDTO;
  navLinks: any[];
  private subRegroupementPlat: Subscription
  private subSave: Subscription;

  dynamicInjector: Injector;

  constructor(private route: ActivatedRoute, private utilSvc: UtilsService,
              private regroupementPlatSvc: RegroupementPlatService,
              private injector: Injector,
              private itemNavigationSvc: ItemNavigationService) {}

  ngOnInit() {
    const groupingId: number = +this.route.snapshot.paramMap.get("id");
    if (groupingId == 0) {
      this.regroupement = new RegroupementPlatDTO();
      this.initNavLinks()
      this.createInjector();
    } else {
      this.getRegroupementPlat(groupingId)
    }
    this.itemNavigationSvc.selectedFlMenuItem = this.itemNavigationSvc.menuItems[11];
    this.itemNavigationSvc.selectedMenuItem['breadcrumb'] = ['Production', 'Conditionnements', 'Regroupement plats points de livraison'];
  }

  private createInjector = ():void => {
    this.dynamicInjector = Injector.create({
      providers: [{provide: 'dynamicData', useValue: this.regroupement}],
      parent: this.injector,
    });
  }


  ngOnDestroy() {
    this.utilSvc.unsubscribe(this.subRegroupementPlat);
    this.utilSvc.unsubscribe(this.subSave);
  }

  private getRegroupementPlat(groupingId: number) {
    const filter: RegroupementPlatFilterMl = new RegroupementPlatFilterMl()
    filter.ids = [groupingId]
    this.subRegroupementPlat = this.regroupementPlatSvc.getRegroupementPlatByFilter(filter).subscribe((res) => {
      if (res) {
        this.regroupement = res.resultList[0];
        this.initNavLinks()
        this.createInjector();
      }
    })
  }

  private initNavLinks() {
    this.navLinks = [];
    this.navLinks.push({
      text: `Fiche d'identité`,
      component: RegroupementPlatDialogFicheTechniqueComponent

    });
    if (this.regroupement.id !== 0) {
      this.navLinks.push({
        text: `Plats`,
        component: RegroupementPlatDialogPlatsComponent
      });
      this.navLinks.push({
        text: `Points de livraison`,
        component: RegroupementPlatDialogPlcComponent
      });
    }
  }
}
